module.exports = __webpack_public_path__ + "img/camera-purple.496fa411.svg";